import { createClient } from "@supabase/supabase-js";

// These should be provided via environment variables in the SteerCode integration
const supabaseUrl = (import.meta.env.VITE_SUPABASE_URL as string) || "";
const supabaseAnonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY as string) || "";

export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

if (!isSupabaseConfigured) {
  console.warn(
    "Supabase env not fully configured. Add VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY so auth works."
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);